import * as React from 'react';
import * as ReactDOM from 'react-dom';
import i18n from '../../../i18n/client-i18n';
import { I18nextProvider } from 'react-i18next';
import { create } from '@wix/fedops-logger';
import { InvoiceViewClient } from './ViewClient';
import { INVOICE_VIEW } from './constants';
import { ErrorBoundary } from '../../../api/error-reporter/error-reporter';
import '@wix/design-system/styles.global.css';

const fedopsLogger = create('price-quotes-server');

fedopsLogger.interactionStarted(INVOICE_VIEW);

export const app = () => (
  <ErrorBoundary>
    <I18nextProvider i18n={i18n(window.__INITIAL_I18N__)}>
      <ErrorBoundary onError={console.error}>
        <InvoiceViewClient
          fedopsLogger={fedopsLogger}
          invoice={window.__INVOICE__}
          recurringInvoiceViewEnabled={
            window.__RECURRING_INVOICE_VIEW_ENABLED__
          }
          status={window.__STATUS__}
          businessInfo={window.__BUSINESS_INFO__}
          invoiceId={window.__INVOICE_ID__}
          invoiceVersion={window.__INVOICE_VERSION__}
          instanceId={window.__INSTANCE_ID__}
          token={window.__TOKEN__}
          isUoU={!!window.__TOKEN__}
          hasPaymentMethods={window.__HAS_PAYMENT_METHODS__}
          data={window.__DATA__}
          footer={window.__FOOTER_LABELS__}
          invoiceNumberLabel={window.__INVOICE_NUMBER_LABEL__}
          isPremium={window.__IS_PREMIUM__}
        />
      </ErrorBoundary>
    </I18nextProvider>
  </ErrorBoundary>
);

ReactDOM.render(app(), document.getElementById('root'));
